/** User-facing message when an admin magic link has expired (IS-1436 / IS-1697 / IMA-2). */
export const ADMIN_MAGIC_LINK_EXPIRED_MESSAGE = 'Your link has expired.';
export const ADMIN_MAGIC_LINK_USED_MESSAGE = 'This link has already been used.';
export const ADMIN_MAGIC_LINK_INVALID_MESSAGE = 'This link is invalid.';
/** Explains expiry rules on the expired/used admin link page (IMA-2). */
export const ADMIN_MAGIC_LINK_EXPIRY_HELP =
  'Admin access links expire after 24 hours or after the first successful use. Enter your email below to receive a new link.';

export type MagicLinkFailureReason = 'expired' | 'used' | 'invalid';

/**
 * Whether AdminPage should show the click-to-continue gate for a URL token.
 * Does not verify automatically — scanners must not consume one-time tokens (IS-1697).
 */
export function shouldPromptAdminTokenContinue(
  token: string | null,
  user: unknown,
  tokenConsumed: boolean
): boolean {
  return Boolean(token && !user && !tokenConsumed);
}

/** @deprecated Use shouldPromptAdminTokenContinue — kept for test compatibility during rename. */
export function shouldVerifyAdminToken(
  token: string | null,
  user: unknown,
  tokenVerified: boolean
): boolean {
  return shouldPromptAdminTokenContinue(token, user, tokenVerified);
}

/**
 * Maps verifyAdminMagicLink HTTP response to an error message, or null on success.
 */
export function getAdminTokenVerificationError(
  responseOk: boolean,
  result: { success?: boolean; error?: string; reason?: MagicLinkFailureReason; details?: string }
): string | null {
  if (responseOk && result.success) {
    return null;
  }

  if (result.reason === 'used') {
    return ADMIN_MAGIC_LINK_USED_MESSAGE;
  }
  if (result.reason === 'invalid') {
    return ADMIN_MAGIC_LINK_INVALID_MESSAGE;
  }
  if (result.reason === 'expired') {
    return ADMIN_MAGIC_LINK_EXPIRED_MESSAGE;
  }

  // Server/auth failures (e.g. signBlob IAM) — do not mislabel as expired
  if (result.error && !result.reason) {
    return result.error;
  }

  return result.error || ADMIN_MAGIC_LINK_EXPIRED_MESSAGE;
}
